<script lang="ts">
    import {
        faSearch,
        faUserPlus,
        faMoneyCheckAlt,
        faStar,
        faSearchDollar,
        faRandom,
        faFileDownload,
        faFileUpload,
        faCoins,
        faWallet,
        faFileInvoiceDollar,
        faReceipt,
        faFileSignature,
        faFileInvoice,
        faShoppingCart,
        faChartLine,
        faPoll,
        faMapSigns,
        faCreditCard,
        faCubes,
        faComments,
        faCalendarAlt,
    } from '@fortawesome/free-solid-svg-icons'
    import { Link, router, navigateTo } from 'yrv'
    import { createEventDispatcher } from 'svelte'
    import Ztouch from './z/ztouch.svelte'
    const dispatch = createEventDispatcher()

    $: documentLink = window.configs?.documentVersionLatest ? '/customer-service-v2/forms' : '/customer-service/entries'

    router.subscribe((e) => {
        dispatch('click')
    })

    function go(url: string) {
        navigateTo(url)
        dispatch('click')
    }
</script>

<div class="m-menu">
    <div class="m-menu_content">
        {#if window.store.token.permissions.persons.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">Pessoas</div>
                <div class="m-menu_buttons">
                    <Ztouch
                        class=""
                        icon={faSearch}
                        label="Pesquisar"
                        on:click={() => {
                            dispatch('click')
                            window.person('search')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class=""
                        icon={faUserPlus}
                        label="Cadastrar"
                        on:click={() => {
                            dispatch('click')
                            window.person('new')
                        }}
                    ></Ztouch>
                </div>
            </div>
        {/if}
        {#if window.store.token.permissions.dashboard.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">Dashboard</div>
                <div class="m-menu_buttons">
                    <Ztouch
                        class="m-menu_dash"
                        icon={faChartLine}
                        label="Início"
                        on:click={() => {
                            go('/dashboard/home')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faSearchDollar}
                        label="Raio-X"
                        on:click={() => {
                            go('/dashboard/x-ray')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faCalendarAlt}
                        label="Agendas"
                        on:click={() => {
                            go('/dashboard/agendas')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faPoll}
                        label="Conversões"
                        on:click={() => {
                            go('/dashboard/conversions')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faMapSigns}
                        label="Origens"
                        on:click={() => {
                            go('/dashboard/referrals')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faCreditCard}
                        label="Meios de pagamento"
                        on:click={() => {
                            go('/dashboard/payments')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faCubes}
                        label="Serviços"
                        on:click={() => {
                            go('/dashboard/services')
                        }}
                    ></Ztouch>
                    <Ztouch
                        class="m-menu_dash"
                        icon={faWallet}
                        label="ZanduPay"
                        on:click={() => {
                            go('/dashboard/zandupay')
                        }}
                    ></Ztouch>
                </div>
            </div>
        {/if}
        {#if window.store.token.permissions.scheduler.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">Agenda</div>
                <div class="m-menu_buttons">
                    <Ztouch
                        class="m-menu_agenda"
                        icon={faCalendarAlt}
                        label="Minha agenda"
                        on:click={() => {
                            go('/agenda/all')
                        }}
                    ></Ztouch>
                </div>
            </div>
        {/if}
        {#if window.store.token.permissions.pos.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">PDV</div>
                <div class="m-menu_buttons">
                    {#if window.store.token.permissions.pos?.sales.navigate}
                        <Ztouch
                            class="m-menu_pos"
                            icon={faShoppingCart}
                            label="Caixa"
                            on:click={() => {
                                go('/pos/entries')
                            }}
                        ></Ztouch>
                    {/if}
                    {#if window.store.token.permissions.pos?.quotes?.read}
                        <Ztouch
                            class="m-menu_pos"
                            icon={faFileInvoice}
                            label="Orçamentos"
                            on:click={() => {
                                go('/pos/quotes')
                            }}
                        ></Ztouch>
                    {/if}
                    {#if window.store.token.permissions.pos?.taxInvoices?.read}
                        <Ztouch
                            class="m-menu_pos"
                            icon={faFileInvoiceDollar}
                            label="Nota Fiscal"
                            on:click={() => {
                                go('/pos/taxes')
                            }}
                        ></Ztouch>
                    {/if}
                </div>
            </div>
        {/if}
        {#if window.store.token.permissions.customerService.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">Atendimento</div>
                <div class="m-menu_buttons">
                    <Ztouch
                        class="m-menu_cs"
                        icon={faFileSignature}
                        label="Atender"
                        on:click={() => {
                            go(documentLink)
                        }}
                    ></Ztouch>
                </div>
            </div>
        {/if}
        {#if window.store.token.permissions.pay.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">ZanduPay</div>
                <div class="m-menu_buttons">
                    {#if window.store.token.permissions.pay.entries.read}
                        <Ztouch
                            class="m-menu_pay"
                            icon={faCreditCard}
                            label="Início"
                            on:click={() => {
                                go('/payments/purchases')
                            }}
                        ></Ztouch>
                    {/if}
                    {#if window.store.token.permissions.pay.entries.read}
                        <Ztouch
                            class="m-menu_pay"
                            icon={faReceipt}
                            label="Parcelas"
                            on:click={() => {
                                go('/payments/charges')
                            }}
                        ></Ztouch>
                    {/if}
                    {#if window.store.token.permissions.pay.links.read}
                        <Ztouch
                            class="m-menu_pay"
                            icon={faFileInvoiceDollar}
                            label="Cobranças"
                            on:click={() => {
                                go('/payments/links')
                            }}
                        ></Ztouch>
                    {/if}
                    {#if window.store.token.permissions.pay.links.read}
                        <Ztouch
                            class="m-menu_pay"
                            icon={faWallet}
                            label="Assinaturas"
                            on:click={() => {
                                go('/payments/subscriptions')
                            }}
                        ></Ztouch>
                    {/if}
                </div>
            </div>
        {/if}
        {#if window.store.token.permissions.financial.show}
            <div class="m-menu_line">
                <div class="m-menu_line_label">Financeiro</div>
                <div class="m-menu_buttons">
                    <Ztouch
                        class="m-menu_financial"
                        icon={faCoins}
                        label="Início"
                        on:click={() => {
                            go('/financial-4/home')
                        }}
                    ></Ztouch>

                    <Ztouch
                        class="m-menu_financial"
                        icon={faFileDownload}
                        label="A Receber"
                        on:click={() => {
                            go('/financial-4/bills-to-receive')
                        }}
                    ></Ztouch>

                    <Ztouch
                        class="m-menu_financial"
                        icon={faFileUpload}
                        label="A Pagar"
                        on:click={() => {
                            go('/financial-4/bills-to-pay')
                        }}
                    ></Ztouch>

                    <Ztouch
                        class="m-menu_financial"
                        icon={faRandom}
                        label="Movimentação"
                        on:click={() => {
                            go('/financial-4/accounts')
                        }}
                    ></Ztouch>
                </div>
            </div>
        {/if}
        <div class="m-menu_line">
            <div class="m-menu_line_label">Mais</div>
            <div class="m-menu_buttons">
                {#if window.store.token.permissions.nps.show}
                    <Ztouch
                        class="m-menu_plus"
                        icon={faStar}
                        label="NPS"
                        on:click={() => {
                            go('/nps/info')
                        }}
                    ></Ztouch>
                {/if}
                {#if window.store.token.permissions.comissions.show}
                    <Ztouch
                        class="m-menu_plus"
                        icon={faMoneyCheckAlt}
                        label="Comissões e salários"
                        on:click={() => {
                            go('/comissions/entries')
                        }}
                    ></Ztouch>
                {/if}
                {#if window.store.token.permissions.goals.show}
                    <Ztouch
                        class="m-menu_plus"
                        icon={faChartLine}
                        label="Metas"
                        on:click={() => {
                            go('/tools-goalboard/dash')
                        }}
                    ></Ztouch>
                {/if}
            </div>
        </div>
    </div>
</div>
